<template>
  <SectionWrapper ref="sectionWrapperRef" className="">
    <div class="absolute inset-0 bg-[#04406E] opacity-60 z-10"></div>
    <HeroSection />
  </SectionWrapper>
  
  <SectionWrapper>
    <FeatureSection />
  </SectionWrapper>
  
  <SectionWrapper>
    <HowItWorkSection />
  </SectionWrapper>
  
  <SectionWrapper>
    <TypeSignalementSection />
  </SectionWrapper>
  
  <SectionWrapper>
    <FaqSection />
  </SectionWrapper>

  <!-- Modal d'avis -->
  <AvisModal
    :show="showAvertissementModal"
    @close="showAvertissementModal = false"
  />
</template>

<script setup lang="ts">
import SectionWrapper from '@/components/layouts/SectionWrapper.vue'
import HeroSection from '@/components/organisms/landing-page/hero-section/index.vue'
import FeatureSection from '@/components/organisms/landing-page/feature-section/index.vue'
import HowItWorkSection from '@/components/organisms/landing-page/how-it-work-section/index.vue'
import TypeSignalementSection from '@/components/organisms/landing-page/type-signalement-section/index.vue'
import FaqSection from '@/components/organisms/landing-page/faq-section/index.vue'
import AvisModal from '@/components/AvisModal.vue'
import { ref, onMounted } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import { useCenteredBackgroundImage } from '@/components/atoms/image/useCenteredBackgroundImage'

// Chemins absolus vers les images dans public/ (Vite sert public/ à la racine /)
const BG_HERO_MOBILE = '/images/landing-page/hero-section/herosection-mobile.png'
const BG_HERO_MEDIUM = '/images/landing-page/hero-section/herosection-medium.png'
const BG_HERO_LARGE = '/images/landing-page/hero-section/herosection-large.png'

const sectionWrapperRef = ref<ComponentPublicInstance | null>(null)
const showAvertissementModal = ref(false)

// Afficher le modal d'avertissement 2 secondes après l'arrivée sur la page
onMounted(() => {
  setTimeout(() => {
    showAvertissementModal.value = true
  }, 2000)
})

useCenteredBackgroundImage(sectionWrapperRef, "", {
  screen_props: {
    mobile_s: {
      screen_size: "100%",
      zoom: 1.2,
      src: BG_HERO_MOBILE
    },
    mobile_m: {
      screen_size: "100%",
      zoom: 1,
      src: BG_HERO_MOBILE
    },
    mobile_l: {
      screen_size: "100%",
      zoom: 1,
      src: BG_HERO_MOBILE
    },
    tablet: {
      screen_size: "100%",
      zoom: 1.9,
      src: BG_HERO_MEDIUM
    },
    laptop: {
      screen_size: "100%",
      zoom: 1.4,
      src: BG_HERO_MEDIUM
    },
    laptop_l: {
      screen_size: "100%",
      zoom: 1,
      src: BG_HERO_MEDIUM
    },
    desktop: {
      screen_size: "100%",
      zoom: 1,
      src: BG_HERO_MEDIUM
    },
    k_screen: {
      screen_size: "100%",
      zoom: 2.2,
      src: BG_HERO_LARGE
    }
  }
})
</script>